import { PAGE_GUIDES, type PageGuideKey } from '../constants/pageGuides';
import { usePageGuideMountGuard } from '../hooks/usePageGuideMountGuard';

import { GuideLink } from './GuideLink';

export type PageGuideLinkProps = {
  /** The page whose header carries the sentence; see PAGE_GUIDES. */
  page: PageGuideKey;
};

/**
 * The page sentence, "Learn more about {topic}", for a route's header
 * (GDN-3704, AC-14). Place it in the header's title row: it renders nothing
 * while the gate is closed or the topic has no published hub, and reserves
 * no space. One per page (AC-6); development warns when two mount together.
 */
export function PageGuideLink({ page }: PageGuideLinkProps) {
  usePageGuideMountGuard();
  const { surfaceId, topic } = PAGE_GUIDES[page];
  return <GuideLink surfaceId={surfaceId} shape="page-sentence" topic={topic} />;
}
